import delve from 'dlv'
import type { FC } from 'react'
import parse from 'html-react-parser'
import classnames from 'classnames'
import { getBlock } from 'lib/model'

interface Props {
  content: any
}

const InstallSuccessPage: FC<Props> = ({ content }) => {
  const { blocks } = delve(content, 'data.attributes')
  const block = getBlock(blocks, 'blocks.installation-successful')
  const { title, icon, text } = block
  return (
    <section className="hero-section">
      <div className="main">
        <section id="install-success" className="pt-5 pb-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-7" style={{ textAlign: 'center' }}>
                <div className="success-wrapper">
                  <i className={classnames('far', icon)}></i>
                  <h1>{title}</h1>
                  {parse(text)}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </section>
  )
}

export default InstallSuccessPage
